$(document).ready(function(){
  
  $('.tab-header-wrap .header-tab').click(function(){
    var tab_id = $(this).attr('data-tab');
    $('.tab-header-wrap .header-tab').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
  
  $('form.site-header__search-form .site-header__search-input').on('input',function(e){
    $(this).closest('[data-section-id="header"]').find('.header-sticky-wrapper').find('#SiteHeader').find('.site-header__search-container').addClass('is-transitioning is-active');
  });
  
  $(".btn-english").click(function(){
    $(".tab-form.english").addClass('active');
    $(".tab-form.spanish").removeClass('active');
    $(this).addClass('active');
    $(".btn-spanish").removeClass('active');
  });
  
  $(".btn-spanish").click(function(){
    $(".tab-form.english").removeClass('active');
    $(".tab-form.spanish").addClass('active');
    $(this).addClass('active');
    $(".btn-english").removeClass('active');
  });

  $('.home-review.home-review-style2 .review-group').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 8,
  slidesToScroll: 8,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 6
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        centerMode: true,
         infinite: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

    $('.review-group').not('.slick-initialized').slick({
  dots: false,
  arrows:true,
  infinite: false,
  slidesToShow: 5,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        centerMode: true,
         infinite: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});


  if ($(window).width() < 769) {

       $('.kit-list-wrap').slick({
  dots: false,
  arrows:true,
  infinite: true,
  slidesToShow:3,
  centerMode: true
});
    
  };
